import { render } from "./AccessValidation.vue?vue&type=template&id=6aebb0b1"
import script from "./AccessValidation.vue?vue&type=script&lang=js"
export * from "./AccessValidation.vue?vue&type=script&lang=js"

import "./AccessValidation.vue?vue&type=style&index=0&id=6aebb0b1&lang=css"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__